var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-right-cmp"},[_c('div',{staticClass:"chart-name"},[_vm._v("\n    攻打白宫月趋势\n    "),_c('dv-decoration-3',{staticStyle:{"width":"200px","height":"20px"}})],1),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }